// Global toast store compatible with shadcn Toaster pattern
import { useEffect, useState } from "react"

export interface ToastOptions {
  title: string
  description?: string
  variant?: "default" | "destructive"
}

interface ToastItem extends ToastOptions {
  id: number
}

// Global state and listeners to share toasts across the app
const listeners = new Set<(toasts: ToastItem[]) => void>()
let globalToasts: ToastItem[] = []

const notify = () => {
  for (const l of Array.from(listeners)) l(globalToasts)
}

export const toast = (options: ToastOptions) => {
  const item: ToastItem = { id: Date.now() + Math.floor(Math.random() * 1000), ...options }
  globalToasts = [...globalToasts, item]
  notify()

  // Auto-remove based on type - 5 seconds for errors, 3 seconds for default
  const duration = options.variant === "destructive" ? 5000 : 3000
  setTimeout(() => {
    globalToasts = globalToasts.filter((t) => t.id !== item.id)
    notify()
  }, duration)
}

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastItem[]>(globalToasts)

  useEffect(() => {
    const listener = (next: ToastItem[]) => setToasts(next)
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }, [])

  return { toast, toasts }
}

